import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalActionType, ModalProps } from '../../../components/Modal';
import api from '../../../config/axios';
import DefaultLayout from '../../../Layout';
import BasicInput from '../../../components/BasicInput';
import ButtonTextIcon, { BtnType } from '../../../components/BtnIcon';

type DataProps = {
    id: number,
    justification: string,
    isActive: boolean
  }

export default function EditClientBlockJustifications() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showToastSuccess, setShowToastSuccess] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [modal, setModal] = useState<ModalProps | null>(null);
  const [token] = useState({ headers: { Authorization: `bearer ${localStorage.getItem('adminToken')}` } });
  const [data, setData] = useState<DataProps>({
    id: 0,
    isActive: false,
    justification: '',
  });

  function enableButton() {
    return data.justification !== '';
  }

  async function saveJustification() {
    try {
      setLoading(true);
      await api.put(`admin/block-life-justifications/${id}`, {
        justification: data.justification,
      }, token);
      setLoading(false);
      setShowToastSuccess(true);
      setTimeout(() => {
        setShowToastSuccess(false);
      }, 3000);
    } catch (err: any) {
      console.log(err.response);
      setModal({ title: 'Ocorreu um erro', children: 'Não foi possível editar categoria', actions: [{ label: 'Ok, entendi', type: ModalActionType.PRIMARY, onClick: () => setModal(null) }] });
    }
  }

  async function fetchJustifications() {
    try {
      setLoading(true);
      const response = await api.get(`admin/block-life-justifications/${id}`, token);
      setData(response.data);
      setLoading(false);
    } catch (err:any) {
      console.log(err.response);
      setModal({ title: 'Ocorreu um erro', children: 'Não foi possível achar justificativa', actions: [{ label: 'Ok, entendi', type: ModalActionType.PRIMARY, onClick: () => navigate('/cliente/motivos-cancelamento') }] });
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchJustifications();
  }, []);

  return (
    <DefaultLayout
      pageTitle="Editar justificativa de cancelamento de clientes"
      loading={loading}
      showToastSuccess={showToastSuccess}
      showToastError={showToastError}
      showRightSlider={false}
      rightSliderContent={undefined}
      modal={modal}
      setCloseRightSlider={() => null}
    >
      <div className="row seller">
        <div className="col-12 p-0 card-bg p-4">
          <h1>Editar justificativa</h1>
          <div className="row">
            <div className="col-4">
              <BasicInput
                id="title-input"
                label="Título"
                readOnly={false}
                helper="Ex: Mudou de país"
                error={data.justification.length < 1 ? 'Campo obrigatório' : ''}
                value={data.justification}
                type="text"
                onChange={(cb) => setData({ ...data, justification: cb })}
              />
            </div>
            <div className="col-12 footer">
              <ButtonTextIcon
                label="Salvar"
                type={BtnType.PRIMARY}
                icon="backup"
                active={enableButton()}
                onClick={() => saveJustification()}
                ref={null}
              />
            </div>
          </div>
        </div>
      </div>

    </DefaultLayout>
  );
}
